import React, { useEffect, useState } from 'react';
import FormatBytes from '~/components/FormatBytes';
import I18nLink from '~/components/I18nLink';
import IconInfoSvg from '~/components/svg/info-icon.svg';
import Config from '~/config';
import PhotoTagsNew from '~/components/PhotoTagsNew';

const ImageInformation = ({
  photo,
  t,
  title,
  tags,
  hasMaxWidth,
  categories,
  lng,
  profile,
}) => {
  const [url, setUrl] = useState({
    loginURL: '',
    signupURL: '',
  });
  const roles = Config.getRoles();

  useEffect(() => {
    setUrl({
      loginURL: `${
        Config.ssoServerUrl
      }/login?lang=${lng}&serviceURL=${encodeURIComponent(
        window.location.href,
      )}`,
      signupURL: `${
        Config.ssoServerUrl
      }/signup?lang=${lng}&serviceURL=${encodeURIComponent(
        window.location.href,
      )}`,
    });
  }, []);

  const { nickname_for_overseas, nickname, id } = photo.creator;

  return (
    <div>
      <div className="image-info-container">
        <h3>
          <IconInfoSvg />
          <span className="info-title">{t('information')}</span>
        </h3>
        <h2
          className="image-info-description"
          dangerouslySetInnerHTML={{
            __html: t('ill_text_description', {
              title,
              user_name: nickname_for_overseas || nickname || photo.user_name,
            }),
          }}
        />
        {(profile.role === undefined || profile.role === roles.GUEST) && (
          <p
            className="image-info-description-guest"
            dangerouslySetInnerHTML={{
              __html: t('ill_text_description_guest', {
                title,
                signupURL: url.signupURL,
                loginURL: url.loginURL,
              }),
            }}
          />
        )}
        <div className="image-info-meta-data">
          <div>
            <span className="info-title">{t('title')}:</span> {title}
          </div>
          <div>
            <span className="info-title">{t('creator')}:</span>{' '}
            {/* TODO: REMOVE THIS COMMENT */}
            {/* <a
              href={`/creator-profile/${id || photo.user_id}`}
              target="_blank"
              rel="noreferrer"
              className="link-to"
            > */}
            {nickname_for_overseas || nickname || photo.user_name}
            {/* </a> */}
          </div>
          <div>
            <span className="info-title">ID:</span> {photo.id}
          </div>
          <div>
            <span className="info-title">{t('download')}:</span>{' '}
            {photo.download_count}
          </div>
          <div>
            <span className="info-title">{t('categories')}:</span>{' '}
            {photo.categories.map((item, index) => (
              <React.Fragment key={item.id}>
                <I18nLink href={`/category/${item.category_slug}`}>
                  <a
                    target="_blank"
                    className={`link-category link-to ${Config.serviceType}`}
                    rel="noreferrer"
                  >
                    {`${
                      index < photo.categories.length - 1
                        ? `${item.category_name}, `
                        : item.category_name
                    }`}
                  </a>
                </I18nLink>
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="image-info-meta-formats">
          <span className="info-title">{t('formats')}:</span>
          <br />
          <ul>
            {photo.assets.map((item) => (
              <li key={item.type}>
                <span className="info-title">{item.type}:</span>{' '}
                <span>
                  {item.width && (
                    <span>{`${item.width} x ${item.height} pixels`}</span>
                  )}
                  ・
                  <FormatBytes value={item.file_size} />
                </span>
              </li>
            ))}
          </ul>
        </div>
        <p className="info-title">{t('related_keywords')}:</p>
        <PhotoTagsNew
          tags={tags}
          itemsToShow={20}
          categories={categories}
          hasMaxWidth={hasMaxWidth}
        />
        <div className="content-confirm-wrapper">
          <div className="right-action">
            <span className="icon-safety">
              <img
                src={`${Config.staticPrefix}/static/assets/image/download-pages/antivirus.svg`}
                width={'24'}
                height={'24'}
                alt="icon safety"
              />
            </span>
            <p>SAFETY</p>
          </div>
          <p
            dangerouslySetInnerHTML={{
              __html: t('content_confirm', {
                usageLink: '/help-page?tab=usage_guides',
              }),
            }}
          />
        </div>
      </div>
      <style jsx>
        {`
          .image-info-container {
            padding: 32px 0;
            border-bottom: 1px solid #e3e3e3;
            border-top: 1px solid #e3e3e3;
            margin: 32px 0;
          }
          h3 {
            margin: 0;
          }
          h3 .info-title {
            margin-left: 8px;
          }
          .info-title {
            font-weight: 700;
            font-size: 16px;
            line-height: 28px;
            color: #170507;
          }
          .image-info-description {
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
            color: #170507;
            margin: 16px 0;
          }
          .image-info-description-guest {
            margin-top: -12px;
            margin-bottom: 16px;
          }
          .image-info-meta-data {
            display: grid;
            grid-column: 1 / 2;
            grid-template-columns: repeat(2, 1fr);
            width: 100%;
            grid-gap: 16px;
          }
          .image-info-meta-formats {
            margin: 16px 0;
          }
          .right-action {
            display: flex;
            align-items: center;
            width: 120px;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #170507;
            overflow: hidden;
          }
          .right-action .icon-safety {
            height: 40px;
            width: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #170507;
          }
          .right-action > p {
            margin: 0;
            font-weight: bold;
            background: #e3e3e3;
            height: 40px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .content-confirm-wrapper {
            display: flex;
            align-items: center;
            margin-top: 16px;
          }
          .content-confirm-wrapper > p {
            margin: 0;
            margin-left: 8px;
          }
        `}
      </style>
    </div>
  );
};

export default ImageInformation;
